/* eslint-disable @typescript-eslint/naming-convention */
import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreenService } from './core/services/splash-screen/splash-screen.service';
import { StatusBarService } from './core/services/status-bar/status-bar.service';
import { ServicesOrchestratorService } from '@app/core/services/services-orchestrator';
import smoothscroll from 'smoothscroll-polyfill';
import { FaConfig } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'he-root',
  templateUrl: 'app.component.html',
})
export class AppComponent {
  constructor(
    private _platform: Platform,
    private splashScreenService: SplashScreenService,
    private statusBarService: StatusBarService,
    private _servicesOrchestratorService: ServicesOrchestratorService,
    private _faConfig: FaConfig,
  ) {
    _faConfig.defaultPrefix = 'fal';
    this.initializeApp();
    // kick off the polyfill!
    smoothscroll.polyfill();
  }

  initializeApp() {
    this._platform.ready().then(() => {
      if (this._platform.is('android')) {
        this.statusBarService.setOverlaysWebView(false);
      }
      if (this._platform.is('capacitor')) {
        this.splashScreenService.hide();
      }
      this._servicesOrchestratorService.start();
    });
  }
}
